import { createContext, Dispatch } from "react";

interface Context {
  selectedAbsenceDate: string;
  setSelectedAbsenceDate?: Dispatch<string>;
  firstDate: string;
  setFirstDate?: Dispatch<string>;
  lastDate: string;
  setLastDate?: Dispatch<string>;
}

const defaultValue: Context = {
  selectedAbsenceDate: new Date().toLocaleString(),
  setSelectedAbsenceDate: () => { },
  firstDate: new Date().toLocaleString(),
  setFirstDate: () => { },
  lastDate: new Date().toLocaleString(),
  setLastDate: () => { },
};

const SelectedContext = createContext<Context>(defaultValue);

export default SelectedContext;
